import {
  PlagiarismActionTypes,
  SET_ASSESSMENTS,
  SET_ASSESSMENT_COMPONENTS,
  SET_REPORT_SUMMARY,
  SET_SEARCH_QUERY,
  GET_ASSESSMENTS,
  GET_ASSESSMENT_COMPONENTS,
  RESET_STATE,
  SET_REPORT_DETAILS_PARAMS,
  SET_REPORT_DETAILS,
  SET_SERIES,
  SET_PROCESSING_ERRORS_LIST,
  GET_SERIES,
} from './types';
import { PlagiarismState } from '../../types/Plagiarism';
import { RESET_GLOBAL_STATE, GlobalActionTypes } from '../types';
import { unknown } from '../actions';

export const initialState: PlagiarismState = {
  seriesData: [],
  seriesLoading: true,
  searchQuery: {},
  search: {
    assessments: [],
    components: [],
  },
  summary: {
    assessments: null,
    components: null,
    reportSummary: null,
    nextPageUrl: undefined,
  },
  details: {
    reportDetailsParams: null,
    similarityRanges: null,
    processingErrors: null,
    nextPageUrl: undefined,
    reportsDetailsTotal: null,
  },
};

export default (
  state = initialState,
  action: PlagiarismActionTypes | GlobalActionTypes = unknown(),
): PlagiarismState => {
  switch (action.type) {
    case GET_SERIES: {
      return {
        ...state,
        seriesLoading: true,
      };
    }

    case SET_SERIES: {
      const {
        payload: { seriesData },
      } = action;

      return {
        ...state,
        seriesData,
        seriesLoading: false,
      };
    }

    case GET_ASSESSMENTS: {
      return {
        ...state,
        search: {
          ...state.search,
          assessments: [],
        },
        summary: {
          ...state.summary,
          assessments: null,
        },
      };
    }

    case SET_ASSESSMENTS: {
      const {
        payload: { assessments },
      } = action;

      return {
        ...state,
        search: {
          ...state.search,
          assessments,
        },
        summary: {
          ...state.summary,
          assessments,
        },
      };
    }

    case GET_ASSESSMENT_COMPONENTS: {
      return {
        ...state,
        search: {
          ...state.search,
          components: [],
        },
        summary: {
          ...state.summary,
          components: null,
        },
      };
    }

    case SET_ASSESSMENT_COMPONENTS: {
      const {
        payload: { components },
      } = action;

      return {
        ...state,
        search: {
          ...state.search,
          components,
        },
        summary: {
          ...state.summary,
          components,
        },
      };
    }

    case SET_REPORT_SUMMARY: {
      const {
        payload: { reportSummary, nextPageUrl },
      } = action;

      return {
        ...state,
        summary: {
          ...state.summary,
          reportSummary: [...(state.summary.reportSummary || []), ...reportSummary],
          nextPageUrl: nextPageUrl,
        },
      };
    }

    case SET_SEARCH_QUERY: {
      const {
        payload: { searchQuery },
      } = action;

      return {
        ...state,
        searchQuery: searchQuery,
      };
    }

    case RESET_STATE: {
      return {
        ...state,
        summary: {
          ...state.summary,
          reportSummary: null,
          nextPageUrl: undefined,
        },
        details: {
          ...state.details,
          similarityRanges: null,
          processingErrors: null,
          nextPageUrl: undefined,
          reportsDetailsTotal: null,
        },
      };
    }

    case SET_REPORT_DETAILS: {
      const {
        payload: { reportDetails, nextPageUrl, reportsDetailsTotal },
      } = action;

      return {
        ...state,
        details: {
          ...state.details,
          similarityRanges: [...(state.details.similarityRanges || []), ...reportDetails],
          nextPageUrl: nextPageUrl,
          reportsDetailsTotal: reportsDetailsTotal ? +reportsDetailsTotal : null,
        },
      };
    }

    case SET_REPORT_DETAILS_PARAMS: {
      const {
        payload: { reportDetailsParams },
      } = action;

      return {
        ...state,
        details: {
          ...state.details,
          reportDetailsParams,
        },
      };
    }

    case SET_PROCESSING_ERRORS_LIST: {
      const { payload } = action;

      return {
        ...state,
        details: {
          ...state.details,
          processingErrors: [...(state.details.processingErrors || []), ...payload.items],
          nextPageUrl: payload.nextPageUrl,
        },
      };
    }
    case RESET_GLOBAL_STATE: {
      return initialState;
    }

    default:
      return state;
  }
};
